import template from './benefitRequestModal.html';
import controller from './benefitRequestModal.controller';
import './benefitRequestModal.scss';

let benefitRequestModalComponent = {
  restrict: 'E',
  bindings: {
    modalId: '@',
    request: '<',
    modalState: '<',
    description: '<',
    modifiedCardCount: '<',
    errorMsg: '<',
    periodCount: '<',
    actionInModal: '&',
    isMobileApp: '<',
    withoutManager:'<',
  },
  template,
  controller,
};

export default benefitRequestModalComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/benefitRequestModal.component.js